import React, { useEffect, useState } from "react";
import axios from "react-axios";
import { useHistory, Redirect } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Modal from 'react-bootstrap/Modal';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic, faShare, faThLarge, faList, faHeart, faSearch } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartEmpty } from "@fortawesome/free-regular-svg-icons";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { Helmet } from "react-helmet";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

import Kba from "../../Components/Elements/Kba";

import { useUser } from "~/Context/userContext";
import CustomPlaylistContainer from "~/Containers/CustomPlaylistContainer";
import TrackImage from "~/Components/Elements/Global/TrackImage";
import { getPlaylistFavorite, setPlaylistFavorite } from "~/api/getCustomPlaylists";
import JukeboxPlayPlaylistCustom from "./JukeboxPlayPlaylistCustom";
import RecentPlaylists from "~/Components/SideNav/RecentPlaylists";
import "./Playlists.less";

const PLAYLIST_VIEW_KEY = "playlistTrackView";


const PlaylistPage = ({ match }) => {
  const { state: userState, dispatch } = useUser();
  let history = useHistory();

  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);
  const [favorited, setFavorited] = useState(false);
  const [compactView, setCompactView] = useState(() => localStorage.getItem(PLAYLIST_VIEW_KEY) === "compact");
  const chooseTrackView = (compact) => {
    setCompactView(compact);
    localStorage.setItem(PLAYLIST_VIEW_KEY, compact ? "compact" : "cards");
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const playlistId = match.params.playlistId;

  useEffect(() => {
    if (!userState.loggedin || !playlistId) {
      setFavorited(false);
      return undefined;
    }
    let cancelled = false;
    getPlaylistFavorite(axios, playlistId)
      .then(({ data }) => {
        if (!cancelled) setFavorited(!!data.favorite);
      })
      .catch(() => {
        if (!cancelled) setFavorited(false);
      });
    return () => {
      cancelled = true;
    };
  }, [playlistId, userState.loggedin]);

  const toggleFavorite = async () => {
    if (!userState.loggedin) {
      dispatch({ type: "signin_open" });
      return;
    }
    try {
      const { data } = await setPlaylistFavorite(axios, playlistId);
      setFavorited(!!data.favorite);
    } catch (error) {
      setFavorited(favorited);
    }
  };

  function handleEditClick() {
    history.push(`/playlist/${playlistId}/edit`);
  }
  const handleGoToSearch = () => {
    history.push(`/search`);
  };
  function createMarkup(text) {
    return { __html: text };
  }
  const sharePlaylist = async (playlist) => {
    const text = `Playlist: "${playlist.name}" on Dream Chimney\nhttps://www.dreamchimney.com/tracks/playlist/${playlist.id}`;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      setCopied(false);
    }
  };
  return (
    <div className="mb-page-m">
      <CustomPlaylistContainer
        playlistId={playlistId}
        render={({ playlist, loading, failure }) => {
          const isOwner = playlist.userDir === userState.user.dir;
          const isCollaborative = Number(playlist.collaborative) === 1;
          const canAddTracks = isOwner || (isCollaborative && userState.loggedin);
          if (failure) {
            return <Redirect to={"/"} />;
          }
          return (
            <React.Fragment>
              {loading ? (
                <div><SkeletonTheme color="#fff" highlightColor="#f3f3f3">
                  <Skeleton count={10} />
                </SkeletonTheme></div>
              ) : (
                <>
                  <Helmet>
                    <title>{playlist.name} Playlist | Dream Chimney</title>
                    <link rel="canonical" href={`https://www.dreamchimney.com/tracks/playlist/${playlistId}`} />
                  </Helmet>
                  <Row>
                    <Col lg={9} md={8} xs={12}>
                      <h2>
                        <div className="playlistTitle">
                          {" "}
                          <FontAwesomeIcon icon={faMusic} style={{ fontSize: 24, marginRight: 14 }} />
                          {playlist.name}
                          {isCollaborative && <span className="playlistCollabBadge">Collaborative</span>}
                        </div>
                        <div className="playlistSubTitle">
                          Playlist by{" "}
                          <Link to={playlist.user.chim_dir ? `/profile/${playlist.user.chim_dir}` : `/user/${playlist.userDir}`}>
                            {playlist.user.full_name}

                            {playlist.user.chim_dir ? ` Chimney` : ``}</Link>
                        </div>
                        {isCollaborative && (
                          <div className="playlistCollabNote">Open for collaboration. Anyone can add tracks to this playlist.</div>
                        )}
                      </h2>
                      {!isOwner && (
                        <button type="button" className={`playlistFavorite${favorited ? " is-on" : ""}`} onClick={toggleFavorite}>
                          <FontAwesomeIcon icon={favorited ? faHeart : faHeartEmpty} />
                          {favorited ? "Favorited" : "Favorite"}
                        </button>
                      )}

                    </Col>
                    <Col lg={3} md={4} xs={12}>
                      <div className="">
                        <JukeboxPlayPlaylistCustom className="hide-mobile" playlistId={playlist.id} playlistName={playlist.name} />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3} xs={12}>
                      {playlist.description && (
                        <div className="playlistDescription">
                          <em><span dangerouslySetInnerHTML={createMarkup(playlist.description)} /></em>
                        </div>
                      )}
                      {isOwner && !playlist.description && (
                        <div className="playlistDescription">
                          <div className="descriptionHelpText" onClick={() => handleEditClick()}>
                            Click here to add a description
                          </div>
                        </div>
                      )}
                      {isOwner && (
                        <div className="playlistEditButtons">



                          {/* <div style={{ marginTop: 20 }}>
                            <Button variant="primary" size="sm" onClick={handleShow}>
                              Add Tracks
                            </Button>
                          </div> */}

                        </div>
                      )}

                      <div className="hide-md-and-below" style={{ marginTop: 40 }}>
                        <RecentPlaylists limit={6} />
                      </div>

                    </Col>
                    <Col lg={9} xs={12}>

                      <div style={{ marginTop: "2px" }}>
                        <div className="playlistTracksHeader">
                          <h3>
                            <span>Tracks ({playlist.tracks.length})</span>
                          </h3>
                          <div className="playlistViewToggle">
                            <button type="button" className={!compactView ? "is-active" : ""} onClick={() => chooseTrackView(false)} title="Card view">
                              <FontAwesomeIcon icon={faThLarge} />
                            </button>
                            <button type="button" className={compactView ? "is-active" : ""} onClick={() => chooseTrackView(true)} title="Compact view">
                              <FontAwesomeIcon icon={faList} />
                            </button>
                          </div>
                        </div>

                        <Container align="center" className="playlistPageMiddle">
                          <Row>
                            <Col md={{ span: 10, offset: 1 }} xs={12}>
                              {isOwner && (
                                <div className="playlistOwnerActions">
                                  <button type="button" className="playlistEditQuiet" onClick={() => handleEditClick()}>
                                    Edit Playlist
                                  </button>
                                </div>
                              )}
                              {playlist.tracks.map((track) => {
                                const addedByLabel = isCollaborative && track.addedByName && track.addedBy !== playlist.userDir
                                  ? `Added by ${track.addedByName}${Number(track.addedByIsChim) === 1 ? " Chimney" : ""}`
                                  : "";
                                if (compactView) {
                                  return (
                                    <Link to={`/${track.id}`} className="playlistCompactRow" key={track.id}>
                                      <TrackImage width="46px" track={track} link={false} />
                                      <span className="playlistCompactTitle">"{track.title}" by {track.artist}</span>
                                      <span className="playlistCompactMeta">
                                        {addedByLabel && <span>{addedByLabel}</span>}
                                        <span>{dayjs(track.postedOn).format("MMM D, YYYY")}</span>
                                      </span>
                                    </Link>
                                  );
                                }
                                return (
                                  <Link to={`/${track.id}`} className="playlistCard" key={track.id}>
                                    <Card body className="m-3 text-left">
                                      <TrackImage width={`120px`} track={track} link={false} />
                                      <span className="trackArtist">
                                        "{track.title}" by {track.artist}
                                      </span>
                                      {addedByLabel && <div className="addedBy">{addedByLabel}</div>}
                                      <div className="date"> Posted On: {dayjs(track.postedOn).format("MMMM D, YYYY")}</div>
                                    </Card>
                                  </Link>
                                );
                              })}
                            </Col>
                          </Row>
                        </Container>

                        {playlist.tracks && playlist.tracks.length === 0 && !canAddTracks && (<p>This playlist is a work in progress... Check back soon.</p>)}
                        {playlist.tracks && playlist.tracks.length === 0 && canAddTracks && (<p>There are currently no tracks in this playlist. Search the archives to add some.</p>)}

                      </div>
                      <Row>
                        <Col xs={12}>
                          <div className="playlistFooter">
                            <div className="playlistShareRow">
                              <Button variant="outline-secondary" size="sm" onClick={() => sharePlaylist(playlist)}>
                                <FontAwesomeIcon icon={faShare} style={{ marginRight: 6 }} />
                                {copied ? "Copied" : "Share"}
                              </Button>
                            </div>
                            <div className="createdDate">
                              Created: {new Date(playlist.datetime).toLocaleDateString()}
                              <br />
                              {playlist.tracks.length > 0 && (
                                <>Last Updated: {new Date(playlist.tracks[playlist.tracks.length - 1].datetime).toLocaleDateString()}</>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>

                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ span: 10, offset: 1 }} xs={12}>
                      {canAddTracks && (
                        <div className="ownerSearch">
                          <p>{isOwner ? "Find more tracks to add to your playlist" : "Find tracks to add to this playlist"}</p>
                          <Button variant="secondary" size="md" onClick={() => handleGoToSearch()}>
                            Search
                          </Button>
                        </div>
                      )}
                      {isCollaborative && !userState.loggedin && (
                        <div className="ownerSearch">
                          <p>Log in to add tracks to this playlist</p>
                          <Button variant="secondary" size="md" onClick={() => dispatch({ type: "signin_open" })}>
                            Log in
                          </Button>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ span: 10, offset: 1 }} xs={12}>
                      {
                        <div className="explorePlaylists">
                          <p>More Playlists to explore</p>
                          <div className="exploreLinks">
                            <Link to="/playlists/recent">
                              <FontAwesomeIcon icon={faMusic} />
                              Recent playlists
                            </Link>
                            {/* {playlist.userDir && playlist.user && (
                              <Link to={`/playlists/user/${playlist.userDir}`}>
                                More by {playlist.user.full_name}
                                {playlist.user.chim_dir ? " Chimney" : ""}
                              </Link>
                            )} */}
                            <Link to="/search">
                              <FontAwesomeIcon icon={faSearch} />
                              Search tracks and start your own
                            </Link>
                          </div>
                        </div>
                      }
                    </Col>
                  </Row>
                  <Row className="divider"></Row>
                  {/* <GenreTracksContainer filter={match.params.genreId} render={(items) => items} /> */}
                  <Kba />
                </>
              )}
            </React.Fragment>
          );
        }}
      />
      {/* <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Modal title</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          I will not close if you click outside me. Don not even try to press
          escape key.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary">Understood</Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};

export default PlaylistPage;
